import { Controller } from "react-hook-form";
import { TextControlProps } from "types";
import ErrorMessage from "../error-message/error-message";
import "./text-control.scss";

const TextControl = (props: TextControlProps) => {
	const { control, getValues, formState: { errors } } = props.formMethods ?? { formState: {} };

	const rules: any = {
		required: props.required && "Dato requerido",
		pattern: props.pattern,
		minLength: props.minLength
	};

	if (props.compareTo) {
		rules.validate = {
			compareTo: (value: string) => {
				const fieldValue = getValues?.(props.compareTo!.fieldToCompare);
				return fieldValue === value || props.compareTo!.message;
			}
		}
	}

	return (
		<div className="inputField">
			<Controller
				name={props.name}
				control={control}
				rules={rules}
				defaultValue={""}
				render={({ field }) =>
					<input
						className={`${errors?.[props.name] && "is-invalid"}`}
						placeholder={" "}
						type={props.type ?? "text"}
						maxLength={props.maxLength}
						autoComplete={props.autoComplete ?? "off"}
						tabIndex={props.tabIndex}
						readOnly={props.readOnly}
						{...field}
					/>
				}
			/>
			<span>{props.label}</span>
			<ErrorMessage error={errors?.[props.name]} />
		</div>
	);
};

export default TextControl;